export function isMac() {
    return navigator.userAgentData 
        ? navigator.userAgentData.platform.toUpperCase().indexOf('MAC') >= 0 
        : navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
}

export function getCtrlSymbol() {
    return isMac() ? '⌘' : 'Ctrl+';
}